import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import {BasePanel} from "@/scenes.ui/base-panel";
import Container = Phaser.GameObjects.Container;
import Sprite = Phaser.GameObjects.Sprite;
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ArtifactBasePanel extends BasePanel {

    private static readonly PI = 3.1415;

    constructor(scene: Scene, canvas: HTMLCanvasElement, slotX: number, slotY: number, container: Container) {
        super(scene, canvas, 0, 327, container);

        let background = SpriteUtils.addSprite(this.scene, 0, 0, Keys.ATLAS_UI, Keys.UI_BLACK);
        SpriteUtils.setDispSize(background, canvas!.width * 2, canvas!.height * 2);

        const window = SpriteUtils.addImage(this.scene, 0, 15, Keys.UI_ART_BASIC_WINDOW).setOrigin(0.5, 0.5).setInteractive();

        const xButton = SpriteUtils.addImage(this.scene, 170, -300, Keys.ATLAS_PROFILE, Keys.UI_ART_X).setOrigin(0.5, 0.5);

        const clickSound = SoundUtils.addSound(scene, Keys.SOUND_SELECT);

        let self = this;
        xButton.setInteractive().on('pointerup', function() {
            if (self.isOnTop()) {
                SoundUtils.play(clickSound);
                self.close();
            }
        });

        let corner = this.createCorner(slotX, slotY);

        this.add([background, window, xButton, corner]);
    }

    private createCorner(slotX: number, slotY: number): Sprite {
        let shiftY = 17;
        if (slotX < -184) {
            if (slotY - this.y > 350) {
                return SpriteUtils.addSprite(this.scene, -173, 342, Keys.ATLAS_PROFILE, Keys.UI_ART_CORNER_DIAG);
            } else {
                return SpriteUtils.addSprite(this.scene, -184, slotY - this.y + shiftY, Keys.ATLAS_PROFILE, Keys.UI_ART_CORNER_LEFT);
            }
        } else if (slotX > 184) {
            if (slotY - this.y > 350) {
                return SpriteUtils.addSprite(this.scene, 172, 342, Keys.ATLAS_PROFILE, Keys.UI_ART_CORNER_DIAG).setRotation(-ArtifactBasePanel.PI / 2);
            } else {
                return SpriteUtils.addSprite(this.scene, 184, slotY - this.y + shiftY, Keys.ATLAS_PROFILE, Keys.UI_ART_CORNER_LEFT).setRotation(ArtifactBasePanel.PI);
            }
        } else {
            return SpriteUtils.addSprite(this.scene, slotX, 350, Keys.ATLAS_PROFILE, Keys.UI_ART_CORNER_LEFT, 0.7).setRotation(-ArtifactBasePanel.PI / 2);
        }
    }
}
